module.exports = __webpack_public_path__ + "static/img/content_shadow.2da36c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/content_shadow.png
// module id = cHXU
// module chunks = 0